/**
 * `S5-4`: **a screen that cannot be built from what the page holds says where to go, and offers the way.**
 *
 * Several routes are URLs over in-memory state (`/eligibilite` needs the simulation the fiche carried; `/vehicule/:id` needs the car read).
 * A reload keeps the path and loses the state, and the screen then had a sentence and nothing to press. The minimum: the sentence, and one
 * button that takes the way the sentence names.
 */
export interface NoWayOutProps {
  readonly testid: string;
  readonly message: string;
  readonly action: string;
  readonly onAction: () => void;
}

export function NoWayOut({ testid, message, action, onAction }: NoWayOutProps): React.JSX.Element {
  return (
    <div className="flex flex-col gap-4 p-6" data-testid={testid}>
      <p className="text-sm text-gray-500">{message}</p>
      <button
        type="button"
        data-testid={`${testid}-action`}
        onClick={onAction}
        className="rounded-2xl bg-indigo-600 px-4 py-3 text-sm font-medium text-white"
      >
        {action}
      </button>
    </div>
  );
}
